import React, { PureComponent } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, SelectField, TablePagination, List, ListItem } from 'react-md';
import DataTable, { createTheme } from 'react-data-table-component';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import Error from '../component/ErrorDispaly.js';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import styles from '../css/styles.css.js';
import editIcon from '../images/png/edit.png';
import crossIcon from '../images/png/crossIcon.png';
import { AppSetting, AppProperties, getDateFormat, IsEmailValid } from '../common/function';

import { confirmAlert } from 'react-confirm-alert';
import StudentModal from './dialogs/StudentModal.js';
import SFBulkUploadButton from '../component/custom/SFBulkUploadButton.js';
import ReactTooltip from 'react-tooltip';
import SFCustomTable from '../component/custom/SFCustomTable.js';
import SFCSVDownloadButton from '../component/custom/SFCSVDownloadButton.js';
import moment from 'moment';



let selectedUserId = [];
export default class StudentEnrollmentList extends PureComponent{
    AppSetting = AppSetting();
    appProperties = AppProperties();
    constructor(props){
        super(props);
        this.state={
            visible: false,
            studentEnrollmentList:[],
            slicedstudentEnrollmentList: [],
            course_id: this.props.location.query.course_id,
            course_name: this.props.location.query.course_name,
            section_name: this.props.location.query.section_name,
            section_id: this.props.location.query.section_id,
            errorMessage: '',
            errorType: '',
            selectedStudents: selectedUserId,
            subsections: [],
            selectedSubSectionID: undefined,
            loading:false,
            bulkUploadLoading: false,
            isCheckBoxEnable: true,
            showStudentDialog: false,
            showBulkUploadErrors: false,
            bulkUploadErrors: null,
            studentErrors: null,
            user: {},
            sections: [],
            checkInactiveStudents: false,
            studentFields: [
              {
                id:'first_name',
                name:'First Name',
                type:'text',
                isRequired: true,
              },
              {
                id:'last_name',
                name:'Last Name',
                type:'text',
                isRequired: true,
              },
              {
                id:'email_id',
                name:'Email',
                type:'text',
                isRequired: true,
                validate: (txt) => {
                  let val = IsEmailValid(txt);
                  return val;
                }
              },
              {
                id:'section_id',
                name:'Section',
                type:'select',
                isRequired: true,
                defaultValue: parseInt(this.props.location.query.section_id, 10),
                disabled: true,
                items: [
                  {
                    label: this.props.location.query.section_name,
                    value: parseInt(this.props.location.query.section_id, 10)
                  }
                ]
              }
            ]
        }
    }

    addBreadCrumbs = () => {
        this.props.replaceBreadCrumb([
          {
            name:(this.appProperties.schoolMode?'All Standards':'All Courses') ,
            type: '',
            onclickPath: 'Courses'
          },
          {
            name: this.state.course_name,
            type: (this.appProperties.schoolMode?'Standards':'Courses'),
            onclickPath:
              'sections?course_id=' +
              this.state.course_id +
              '&course_name=' +
              this.state.course_name
          },
          {
            name: this.state.section_name,
            type: 'Sections',
            onclickPath: 
               'sectionTabs?section_id=' +
               this.state.section_id +
               '&section_name=' +
               this.state.section_name +
               '&course_id=' +
               this.state.course_id +
               '&course_name=' +
               this.state.course_name
          }
        ]);
      };

    componentWillMount() {
        this.getStudentEnrollmentList()
      };
      
      getStudentEnrollmentList= () =>{
        var cour_id = parseInt(this.state.course_id, 10);
        var sec_id = parseInt(this.state.section_id, 10);
        const payload = {
          section_id: sec_id,
          course_id: cour_id,
          subsection_id: 0,
        };
        this.setState({
          loading:true
        });
        ApiRequestService({
          method: 'post',
          url: '/getAllStudentEnrollmentByID',
          data: payload
        }).then(res => {
          this.setState({
            loading:false
          });
          if (res.data.data != null) {
            let studentList = res.data.data
            let studentdata = studentList.slice(0,20)
            this.setState({
                studentEnrollmentList: res.data.data,
                slicedstudentEnrollmentList: studentdata
              });
            }else {
            this.setState({
              studentEnrollmentList: [],
              slicedstudentEnrollmentList: []
            });
            }
        });
      }

      componentWillUpdate() {
        this.addBreadCrumbs();
      };

      componentWillUnmount() {
        this.removeBreadCrumbs();
      }

      componentDidMount() {
        this.subSectionListBySection();
      }
    
      removeBreadCrumbs = () => {
          this.props.replaceBreadCrumb([
          ]);     
      };

      handleChange = (state) => {
        // You can use setState or dispatch with something like Redux so we can use the retrieved data
        let selectedUserId = state.selectedRows.map((user) => user.userid)
        let BulkEnable = selectedUserId.length > 0 ? false : true;
        this.setState({selectedStudents: selectedUserId,isCheckBoxEnable: BulkEnable})
      };

      
      
      subSectionListBySection = () =>{
        var cour_id = parseInt(this.state.course_id, 10);
        var sec_id = parseInt(this.state.section_id, 10);
        const payload = {
          section_id: sec_id,
          course_id: cour_id,
        };
        this.setState({
          loading:true
        });
        ApiRequestService({
          method: 'post',
          url: '/getAllSubSections',
          data: payload
        }).then(res => {
          this.setState({
            loading:false
          });
          console.debug("res.data.data." ,res.data.data)
          if (res.data.data.subsection_names != null) {
             let tempSubsectionList = [] 
             res.data.data.subsection_names.map((data) =>{
              tempSubsectionList.push({value:data.subsection_id, label: data.subsection_name})
             })
             tempSubsectionList.filter(({value})=> value != this.state.subsection_id )
             this.setState({
             subsections: tempSubsectionList.filter(({value})=> value != this.state.subsection_id)
             });

            console.debug("res.data.data.subsection_names" ,res.data.data.subsection_names)             

             /* let subsectionField = {
              id:'subsection_id',
              name:'Sub Section',
              type:'select',
              isRequired: true,
              items: res.data.data.subsection_names.map(sec => {
                return {
                  label: sec.subsection_name,
                  value: sec.subsection_id
                }
              })
            };
             let sectionField = {
              id:'section_id',
              name:'Section',
              type:'select',
              isRequired: true,
              items: [{
                label: this.state.section_name,
                value: parseInt(this.state.section_id, 10),
              }]
            };
  
            console.debug("subsectionField", subsectionField)

            this.setState({
              sections: res.data.data.section_names,
              fields: [
                ...this.state.fields,
                sectionField,
                subsectionField
              ]
            }); */

           }
        });
      }

      BulkUpdate = () => {
        var cour_id = parseInt(this.state.course_id, 10);
        var sec_id = parseInt(this.state.section_id, 10);
        var subsec_id = parseInt(this.state.subsection_id, 10);
        const payload = {
          section_id: sec_id,
          course_id: cour_id,
          subsection_id: subsec_id,
          selected_subsection_id: this.state.selectedSubSectionID,
          selected_student_array: this.state.selectedStudents
        };
        this.setState({
          loading:true
        });
        ApiRequestService({
          method: 'post',
          url: '/moveStudentsToSubsection',
          data: payload
        }) .then(res => {
          if (
              res && res.data && res.data.data
          ){
              NotificationManager.success('Updated Successfully!', 'Success', 3000);
              this.getStudentEnrollmentList();
              selectedUserId = [];
              this.setState({ loading :false , selectedSubSectionID: undefined, isCheckBoxEnable: true, visible: false});
          }
          })
      .catch(error => {
        NotificationManager.error(error,"Error",5000);
        }).finally(()=>{
          selectedUserId = [];
          this.setState({ loading :false, selectedSubSectionID: undefined, isCheckBoxEnable: true, visible: false});
      });
      }

      show = () => {
        this.subSectionListBySection()
        this.setState({ visible: true });
      };
    
      hide = () => {
        this.setState({
          visible: false,
          selectedSubSectionID: undefined
        });
      };

      onSubSectionSelected = (value, index, event, details) =>{
        this.setState({selectedSubSectionID:value});
    }

    RandomAllotment = () => {
      var cour_id = parseInt(this.state.course_id, 10);
      var sec_id = parseInt(this.state.section_id, 10);
      
      const payload = {
        section_id: sec_id,
        course_id: cour_id,
        selected_student_array: this.state.selectedStudents
      };

      for (let selectedStudent of this.state.selectedStudents) {
        let isStudentsAlreadyEnrolled = this.state.studentEnrollmentList.find((student) => 
        student.userid === selectedStudent && student.subsection_id !== 0
        )
        if (isStudentsAlreadyEnrolled) {
          return NotificationManager.error("Selected Student(s) had Already Enrolled In Subsection","Error",5000);
        }
      }
      this.setState({
        loading:true
      });
      ApiRequestService({
        method: 'post',
        url: '/allotStudentsToSubsection',
        data: payload
      }) .then(res => {
        if (
            res && res.data && res.data.data
        ){
            NotificationManager.success('Updated Successfully!', 'Success', 3000);
            this.getStudentEnrollmentList();
            selectedUserId = [];
            this.setState({ loading :false , selectedSubSectionID: undefined, isCheckBoxEnable: true, visible: false});
        }
        })
    .catch(error => {
      NotificationManager.error(error,"Error",5000);
      }).finally(()=>{
        selectedUserId = [];
        this.setState({ loading :false, selectedSubSectionID: undefined, isCheckBoxEnable: true, visible: false});
    });
    }

    show = () => {
      this.subSectionListBySection()
      this.setState({ visible: true });
    };
  
    hide = () => {
      this.setState({
        visible: false,
        selectedSubSectionID: undefined
      });
    };

    onSubSectionSelected = (value, index, event, details) =>{
      this.setState({selectedSubSectionID:value});
  }

    handleStudentDialogChange = () =>{
      console.debug("handleStudentDialogChange")
      this.setState({
        showStudentDialog: !this.state.showStudentDialog,
      })
    }

    deleteMapping = (id, course_id, section_id, userId) => {
      let payload = {
        course_id: course_id,
        section_id: section_id,
        userId: userId
      }
           
      ApiRequestService({
        method: 'post',
        url: '/deleteStudentSectionEnrollment',
        data: payload
      }).then(res => {
        if (res.data.message !== null && res.data.message !== "") {
          NotificationManager.error(res.data.message, "Error");
        } else {
          let updatedStudentEnrollmentList = this.state.studentEnrollmentList;
          let index = updatedStudentEnrollmentList.findIndex(ele => ele.id === id);
          if (index > -1) {
            updatedStudentEnrollmentList.splice(index, 1)
          }
          this.setState({
            studentEnrollmentList: updatedStudentEnrollmentList,
            slicedstudentEnrollmentList: updatedStudentEnrollmentList.slice(0, 20)
          })
        }
      })
    }

    deleteStudentSectionEnrollment = (data) => {
      console.debug("data", data)

      confirmAlert({
        title: `Do you really want to delete "${data.userid}" section enrollment?`,
        message: 'Press "Yes" to submit',
        cancelLabel: 'Yes',
        confirmLabel: 'Cancel',
        onCancel: () => this.deleteMapping(data.id, data.course_id, data.section_id, data.userid)
        
      })
    }
    
    handleEditStudent = (data) => {
      this.setState({
        showStudentDialog: true,
        user: data,
      })
    }

    handlePagination = (start, rowsPerPage) => {
      let studentListData = this.state.studentEnrollmentList
      this.setState({
        slicedstudentEnrollmentList: studentListData.slice(start, start + rowsPerPage)
      });
    };


    onAddStudentComplete = (data) => {
      console.debug("added student", data)
      if (data) {
        let allStudents = [...this.state.studentEnrollmentList, data];
        if (data.email_student) {
          data.emailedTimestamps = [new Date()];
        } else {
          data.emailedTimestamps = null;
        }
        
        let slicedStudents = allStudents.slice(0, 20);
        this.setState({
          studentEnrollmentList: allStudents,
          slicedstudentEnrollmentList: slicedStudents,
          showStudentDialog: false,
        })
        if (data.email_student) {
          NotificationManager.success('Successfully added the student and automatically emailed the one-time code', 'Success', 5000);
        } else {
          NotificationManager.success('Successfully added the student', 'Success', 5000);
        }
        
      }
    }
    onUpdateStudentComplete = (data) => {
      console.debug("update student", data)
      if (data) {
        let allStudents = [...this.state.studentEnrollmentList];
        let index = allStudents.findIndex(u => u.userid === data.userid);
        if (index > -1) {
          allStudents[index] = {
            ...allStudents[index],
            ...data
        };
        }
        let slicedStudents = allStudents.slice(0, 20);
        this.setState({
          studentEnrollmentList: allStudents,
          slicedstudentEnrollmentList: slicedStudents,
          showStudentDialog: false,
        })
        NotificationManager.success('Updated the student successfully', 'Success', 3000);
      }
    }

    handleResendActivationEmailClick = () => {

      for (let i = 0; i < this.state.selectedStudents.length; i++) {
        const userName = this.state.selectedStudents[i];
        let userData = this.state.studentEnrollmentList.find(user => user.userid === userName && !user.active);
        if (!userData) {
          
          NotificationManager.warning('You have selected active students. Please deselect them.', 'Warning', 5000);
          return;
        }
      }
      let payload = this.state.selectedStudents.map(name => {
        return {
          userid: name, 
          course_name: this.state.course_name,
          section_name: this.state.section_name,
        }
      })
      ApiRequestService({
        method: 'post',
        url: '/resendActivationEmail',
        data: payload
      }).then(res => {
        console.debug("res.data>>?>>", res.data)
        if (res && res.data && res.data.status === 0) {
          // update the student emailed_at
          console.debug("this.state.studentEnrollmentList", this.state.studentEnrollmentList)
          let updatedStudents = this.state.studentEnrollmentList.map(student => {
            let index = payload.findIndex(data => data.userid === student.userid)
            if (index > -1) {
              return {
                ...student,
                emailedTimestamps: student.emailedTimestamps ? [...student.emailedTimestamps, new Date()]  : [new Date()]
              }
            }
            return student;
          })

          console.debug("updatedStudents>>>", updatedStudents)

          this.setState({
            studentEnrollmentList: updatedStudents,
          })

          NotificationManager.success('Activation email has been successfully sent to the selected students', 'Success', 6000);
        }
      })
    }

    handleActivateStudentsClick = () => {

      for (let i = 0; i < this.state.selectedStudents.length; i++) {
        const userName = this.state.selectedStudents[i];
        let userData = this.state.studentEnrollmentList.find(user => user.userid === userName && !user.active);
        if (!userData) {
          
          NotificationManager.warning('You have selected active students. Please deselect them.', 'Warning', 5000);
          return;
        }
      }

      ApiRequestService({
        method: 'post',
        url: '/activateStudents',
        data: this.state.selectedStudents
      }).then(res => {
        console.debug("res.data>>?>>", res.data)
        if (res && res.data && res.data.status === 0) {
          let updatedStudentsArr = this.state.studentEnrollmentList.map(student => {
            if (this.state.selectedStudents.includes(student.userid)) {
              return {
                ...student,
                active: true
              }
            }
            return {...student}
          })
          this.setState({
            checkInactiveStudents: false,
            selectedStudents: [],
          }, () => {
            this.setState({
              studentEnrollmentList: updatedStudentsArr,
            })
          })
          NotificationManager.success('Successfully activate the selected students', 'Success', 3000);
        }
      })
    }

    handleBulkUpload = (data) => {
      let courseID = parseInt(this.state.course_id, 10);
      let sectionID = parseInt(this.state.section_id, 10);
      let payloadArr = data.map(data => ({ ...data, course_id: courseID, section_id: sectionID, 
          course_name: this.state.course_name,
          section_name: this.state.section_name,
        }));
      this.setState({
        bulkUploadLoading: true
      });
      ApiRequestService({
        method: 'post',
        url: '/addBulkStudentByInstructor',
        data: payloadArr
      }).then(res => {
        if (res && res.data && res.data.status === 0) {
          let userArr = res.data.data.filter(u => u.error_str === "");
          let errorArr = res.data.data.filter(u => u.error_str !== "");
          if (errorArr && errorArr.length) {
            let dataArr = errorArr.map(error => {
              return {
                FirstName: error.first_name,
                LastName: error.last_name,
                Email: error.email_id,
              }
            })
            this.setState({
              showBulkUploadErrors: true,
              bulkUploadErrors: errorArr,
              studentErrors: dataArr,
            })
          }

          if (errorArr && errorArr.length && userArr && userArr.length) {
            NotificationManager.success(
                `${userArr.length} student${userArr.length > 1 ? "s have" : " has"} been successfully added and emailed them a one time code. ${errorArr.length} student${errorArr.length > 1 ? "s" : ""} encountered errors.`,
                "Partial Success", 7000
            );
        } else if (userArr && userArr.length) {
            NotificationManager.success(
                `${userArr.length} student${userArr.length > 1 ? "s have" : " has"} been successfully added and emailed them a one time code.`,
                "Success", 7000
            );
        } else if (errorArr && errorArr.length) {
            NotificationManager.error(
                `${errorArr.length} student${errorArr.length > 1 ? "s" : ""} encountered errors.`,
                "Error", 7000
            );
        } else {
              NotificationManager.info(
                  "No students were processed.",
                  "Info",
                  5000
              );
          }
        

          let dataWithSectionName = userArr.map(data => {
            // let section = this.state.sections.find(sec => sec.section_id === data.section_id);
            return { ...data, emailedTimestamps: [new Date()], section_name: this.state.section_name }
          })
          let studentData = [...this.state.studentEnrollmentList, ...dataWithSectionName];
          this.setState({
            studentEnrollmentList: studentData,
            slicedstudentEnrollmentList: studentData.slice(0, 20),
          })
        }
      }).finally(() => {
        this.setState({
          bulkUploadLoading: false
        })
      })
  
    }

    render(){
    const { subsections,selectedSubSectionID, isCheckBoxEnable} = this.state;
    const columns = [
      {
        name: 'SF ID',
        selector: 'id',
        sortable: true,
        width:'100px'
      },
      {
        name: 'Username',
        selector: 'userid',
        width:'150px',
        sortable: true,
      },
      {
        name: 'First Name',
        selector: 'first_name',
        sortable: true,
        width:'150px',
      },
      {
        name: 'Last Name',
        selector: 'last_name',
        sortable: true,
        width:'150px',
      },
      {
        name: 'Email',
        selector: 'email_id',
        sortable: true,
        width:'200px',
      },
      {
        name: 'Subsection',
        selector: 'subsection_name',
        sortable: true,
        omit: this.props.hideSubsection ? true : false
      },
      {
        name: 'Status',
        selector: 'active',
        sortable: true,
        center: true,
        cell: (data) => {
           return (
           <div>

             <ReactTooltip id='active-status'  className='tool-tip'>
              Active
            </ReactTooltip>
             <ReactTooltip id='inactive-status'  className='tool-tip'>
              Inactive
            </ReactTooltip>
              <div 
                data-tip 
                data-for={data.active ? "active-status" : "inactive-status"}
                style={{
                borderRadius:'10px',
                color:'white', 
                width:'20px',
                height:'20px',
                background: data.active ? '#2e7d32' : '#bb0000',
                display:'flex',
                justifyContent:'center',
                alignItems:'center'
              }}>
                {/* {data.active ? "Active" : "Inactive"} */}
              </div>
           </div>
          )
          /* return (
            <div style={{
              padding:'4px 8px',
              borderRadius:'4px',
              color:'white', 
              background: data.active ? '#2e7d32' : '#bb0000'
            }}>
              {data.active ? "Active" : "Inactive"}
            </div>
          ) */
        }
      },
      {
        name: 'Created At',
        selector: 'created_at',
        sortable: true,
        width:'200px',
        cell: (data) => {
          let date = getDateFormat(data.created_at);
          return (
            <div>
              {date}
            </div>
          )
        }
      },
      {
        name: 'Created By',
        selector: 'created_by',
        sortable: true,
        width:'150px',
        cell: (data) => {
          if (data.created_by === "self") {
            return "Self Registered";
          }
          return data.created_by;
        }
      },
      {
        name: 'Emailed At',
        selector: 'emailedTimestamps',
        sortable: true,
        width: '250px',
        cell: (data) => {
          if (data?.emailedTimestamps === null) return "N/A"
          return (
            <div style={{
              
            }}>
              {data?.emailedTimestamps?.map((timestamp, index) => (
                <div style={{fontSize:'12px'}} key={index}>{moment(timestamp).format('MM/DD/YYYY, h:mm A')}</div>
              ))}
            </div>
          )
        }
      },
      {
        name: 'Actions',
        sortable: true,
        cell: (data) => {
          return <div style={{display:'flex', justifyContent:'flex-start'}}>
            <Button icon tooltipLabel="Edit" onClick={() => {
                  let newData = {
                    ...data,
                    section_id: parseInt(this.state.section_id, 10),
                  }
                  this.handleEditStudent(newData)
                }}>
                <img src={editIcon} alt="Edit"  />
            </Button>
            {/* <Button style={{
              //display: this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX.includes("osu") ? 'none' : 'inline-block'
            }} icon tooltipLabel="Remove" onClick={() => {
                this.deleteStudentSectionEnrollment(data)
              }}>
                <img src={crossIcon} alt="Remove"  />
            </Button> */}
          </div>
        }
      },
    ];

    const customStyles = {
      headCells: {
        style: {
          fontSize: '14px', 
          fontWeight: 'bold',
        },
      }, 
    };

    let button =(
        <Button   style={ styles.addButton} onClick={this.BulkUpdate} disabled={selectedSubSectionID ? false : true}>
          Move Student(s)
        </Button>
      );
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);
        return (
            (this.state.loading)?
               <LoadingSpinner loading={this.state.loading} />
            :
            <SecureShow targetRole={1}>
              <div>
                {/* <div onClick = {this.subjPage} style={subjPage}>Courses >  </div>
                  <div onClick = {this.sectionPage} style={sectionPage}>Sections</div> */}
      
                <div style={styles.sectionTitle}>
                  Students under - {this.state.section_name}  ({this.state.studentEnrollmentList.length})
                  {(parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10)) >= 1 ? (
                  <div style={{...styles.floatRight, display: this.props.hideSubsection ? 'none' : 'block'}}>
                  <Button className="archive-button" primary raised disabled={isCheckBoxEnable}
                    style={{float: "right"}}
                      onClick={() => this.show(true)}>
                      Move to another Subsection
                    </Button>
                    <Button className="archive-button" primary raised disabled={isCheckBoxEnable}
                    style={{float: "right",marginRight:"10px"}}
                      onClick={() => this.RandomAllotment()}>
                      Random Allotment
                    </Button>
                  </div>
                ) : (
                      ''
              )}
                </div>
      
                <DialogContainer
                  id="simple-action-dialog"
                  visible={this.state.visible}
                  onHide={this.hide}
                  actions={actions}
                  width="500px"
                  modal
                  contentClassName="md-grid copy-quiz-dialog"
                  //title="New Section"
                >
                <p style={{fontSize:"medium"}}><label for="secId">Select Subsection</label></p>
                <SelectField 
                  id='Subsection'
                  placeholder="Select SubSection"
                  menuItems={subsections}
                  onChange={this.onSubSectionSelected}
                  className="gradebook-dropdown"
                  value={this.state.selectedSubSectionID} />
                </DialogContainer>

                {/* Add student/Bulk upload students */}
                <div style={{display:'flex', justifyContent:'flex-end', alignItems:'flex-start', gap:'8px', marginBottom:"1rem"}}>
                  <div>
                    <Button 
                      data-tip data-for='resend-activation'
                      disabled={this.state.selectedStudents?.length === 0}
                      style={{marginRight:'10px'}} primary raised onClick={() => {
                        this.handleActivateStudentsClick()
                      }}>
                        Activate Students
                      </Button>
                      <Button 
                      data-tip data-for='resend-activation'
                      disabled={this.state.selectedStudents?.length === 0}
                      style={{marginRight:'10px'}} primary raised onClick={() => {
                        this.handleResendActivationEmailClick()
                      }}>
                        Resend Activation Email
                        
                      </Button>

                      {this.state.selectedStudents?.length === 0 ? 
                        <ReactTooltip id='resend-activation' type='light' className='tool-tip'>
                          <span>Please select atleast one inactive students.</span>
                        </ReactTooltip>
                      : null}
                      <Button primary raised onClick={() => {
                        this.setState({ user: null, showStudentDialog: true })
                      }}>
                        Add Student
                      </Button>
                  </div>
                  <div>
                  <SFBulkUploadButton
                    tooltip="Download this CSV template to input student details and upload for bulk enrollment. A one-time code will be emailed to each student automatically."
                    loading={this.state.bulkUploadLoading}
                    templateFileName='student_template'
                    headers={["FirstName", "LastName", "Email"]}
                    handleBulkUpload={this.handleBulkUpload}
                    config={
                      {
                        headers: [
                            {
                                name: 'FirstName',
                                inputName: 'first_name',
                                required: true,
                                requiredError: function (headerName, rowNumber, columnNumber) {
                                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                                }
                            },
                            {
                                name: 'LastName',
                                inputName: 'last_name',
                                required: true,
                                requiredError: function (headerName, rowNumber, columnNumber) {
                                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                                }
                            },
                            {
                                name: 'Email',
                                inputName: 'email_id',
                                unique: true,
                                uniqueError: function (headerName) {
                                    return `${headerName} is not unique`
                                },
                                validate: function (email) {
                                    let val = IsEmailValid(email);
                                    return val === "";
                                },
                                validateError: function (headerName, rowNumber, columnNumber) {
                                    return `${headerName} is not valid in the ${rowNumber} row / ${columnNumber} column`
                                }
                            },
                        ]
                    }
                    }
                  />
                  </div>
                  
                  {/* Student Dialog */}
                  <StudentModal 
                    showDialog={this.state.showStudentDialog}
                    fields={this.state.studentFields}
                    data={this.state.user}
                    handleHide={() => this.setState({showStudentDialog:false})}
                    onAddStudentComplete={this.onAddStudentComplete}
                    onUpdateStudentComplete={this.onUpdateStudentComplete}
                    courseID={parseInt(this.state.course_id)}
                    sectionID={parseInt(this.state.section_id)}
                    course_name={this.state.course_name}
                    section_name={this.state.section_name}
                  />

                  <DialogContainer
                    visible={this.state.showBulkUploadErrors}
                    title="Bulk Upload Failures"
                    focusOnMount={false}
                    closeOnEsc={false}
                    width={800}
                    actions={[
                      <Button primary flat onClick={() => {
                        this.setState({
                          showBulkUploadErrors: false,
                          bulkUploadErrors: null
                        })
                      }}>
                        Cancel
                      </Button>,
                      <SFCSVDownloadButton 
                        title="Download CSV"
                        filename="students.csv"
                        data={this.state.studentErrors}
                      />
                      
                    ]}
                  >
                    <div style={{ marginLeft: '1.6rem' }}>
                      <p>Following users are not added due to the errors:</p>
                    </div>
                    <List>
                      {this.state.bulkUploadErrors && this.state.bulkUploadErrors.map((bulkUploadError, index) => {
                        return <ListItem key={index} primaryText={
                          <div>
                              <b>{bulkUploadError.email_id}: </b>
                              <span>{bulkUploadError.error_str}</span>
                          </div>
                        } />
                      })}
                    </List>

                  </DialogContainer>
                    
                </div>
                
                <div style={{marginLeft:"80%"}}>
                  {/* <TablePagination
                    rowsPerPageItems={[10, 20, 50, 100]}
                    defaultRowsPerPage={20}
                    rows={this.state.studentEnrollmentList.length}
                    rowsPerPageLabel=""
                    onPagination={this.handlePagination}
                  /> */}
                </div>
                <span style={{marginLeft:"100px", marginRight:"100px", position:"relative"}}>
                <div style={{
                  position:'absolute',
                  top:'20px',
                  left:'-56px',
                  width:'400px',
                  zIndex: 9,
                }}>
                  <input type="checkbox" id="check_inactive_students" name="check_inactive_students" checked={this.state.checkInactiveStudents} 
                    onClick={(event) => {
                      let isChecked = event.target.checked;
                      let selectedStudents = [];
                      if (isChecked) {
                        selectedStudents = this.state.studentEnrollmentList.filter(user => !user.active).map(user => user.userid)
                      } else {
                        selectedStudents = []
                      }

                      if (selectedStudents && selectedStudents.length === 0 && isChecked) {
                        NotificationManager.warning('No inactive students present', 'Warning', 2000);
                      }
                      this.setState({
                        checkInactiveStudents: isChecked,
                        selectedStudents: selectedStudents,
                        studentEnrollmentList: [...this.state.studentEnrollmentList]
                      })
                      
                    }}
                  />
                  <label for="check_inactive_students">Check Inactive Students </label>
                </div>
                  <SFCustomTable 
                    columns={columns}
                    selectableRows={true}
                    onSelectedRowsChange={this.handleChange}
                    data={this.state.studentEnrollmentList}
                    selectedData={this.state.selectedStudents}
                    topPagination={true}
                    bottomPagination={true}
                    defaultRowsPerPage={20}
                    onPagination={this.handlePagination}
                  />
                {/* <DataTable 
                columns={columns}
                data={this.state.slicedstudentEnrollmentList !== null ? this.state.slicedstudentEnrollmentList: null}
                //selectableRows={this.props.hideSubsection ? false : true}
                selectableRows
                onSelectedRowsChange={this.handleChange}
                customStyles={customStyles}
                /> */}
                </span>
                <div style={{marginLeft:"80%"}}>
                  {/* <TablePagination
                    rowsPerPageItems={[10, 20, 50, 100]}
                    defaultRowsPerPage={20}
                    rows={this.state.studentEnrollmentList.length}
                    rowsPerPageLabel=""
                    onPagination={this.handlePagination}
                  /> */}
                </div>
                {/* <DataTable id="studentEntrollment" baseId="Student"  onRowToggle={this.selectedStudentRows} style={styles.sectionTable}>
                <TableHeader  style={styles.thead}>
                  <TableRow >
                  <th> Lastname.n</th>
                  <th> First Name</th>
                  <th> Last Name</th>
                  <th> OSU ID</th>
                  </TableRow>
                </TableHeader>
                  <TableBody>
                  {tbody}
                  </TableBody>
              </DataTable> */}
                <Error
                  type={this.state.errorType}
                  message={this.state.errorMessage}
                />
              </div>
            </SecureShow>
          );
    }
} 